import { configureStore } from "@reduxjs/toolkit";
import { formAnswerReducer } from "./reducers";

const store = configureStore({
  reducer: {
    // Map reducer to state
    formAnswer: formAnswerReducer,
  },
});

export default store;
